import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/components/Page'
import Post from '@/components/Post'
import Authors from '@/components/Authors'
import Postlist from '@/components/Postlist'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        post: 'about'
      },
      component: Page
    },
    {
      path: '/sobre',
      name: 'sobre',
      meta: {
        post: 'autores'
      },
      component: Authors
    },
    {
      path: '/:type/:slug',
      name: 'post',
      props: true,
      component: Post
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js